import { useState } from 'react'
import { View, TouchableOpacity } from 'react-native'
import { Image } from 'expo-image'
import Page from '@shell/Page'
import Typography from '@ui/typography'
import Input from '@ui/forms/Input'
import { useTempleActions, useTempleSearch } from 'hooks/temple/useTemples'

export default function DevTemplesPage() {
  const [query, setQuery] = useState('')

  const search = useTempleSearch({ query, limit: 20 })
  const { saveTemple, save } = useTempleActions()

  return (
    <Page stage="dev">
      <View className="flex gap-12 p-16">
        <View className="flex gap-8">
          <Typography variant="MDB">Search</Typography>
          <Input
            value={query}
            onChangeText={setQuery}
            placeholder="Search temples"
          />
        </View>

        <View className="flex gap-12">
          {search.isLoading && <Typography>Loading…</Typography>}
          {search.data?.data?.map((t: any) => (
            <TouchableOpacity
              key={t.id}
              onPress={() => saveTemple(t)}
              disabled={save.isPending}
            >
              <View className="rounded-8 bg-white/5 p-12">
                <Image source={t.url} />
                <Typography variant="MDB">{t.name}</Typography>
                <Typography variant="XS" className="color-desc">
                  {t.id}
                </Typography>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    </Page>
  )
}
